// Copyright (c) 2024 Goffy. This file belongs to Goffy. All Rights Reserved.

import { StyleSheet } from 'react-native';

import { Text, View } from './Themed';
import { useUser } from '@/app/user-context';

export function UserBadge({ debug }: { debug?: boolean }) {
  const { user } = useUser();

  if (!debug) {
    return null;
  }

  return (
    <View style={styles.container}>
      <Text style={styles.label}>Inloggad</Text>
      {user ? (
        <Text style={styles.value}>
          {user.forename} ({user.id})
        </Text>
      ) : (
        <Text style={styles.value}>Ingen</Text>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: 8,
  },
  label: {
    fontSize: 12,
    color: '#6b7280',
    marginBottom: 4,
  },
  value: {
    fontSize: 16,
    fontWeight: '600',
  },
});
